<app-report-header
  class="d-none d-print-block"
  [routeName]="route.name"
></app-report-header>

<app-report-summary
  class="d-none d-print-block mt-3"
  [route]="route"
></app-report-summary>

<h4 class="d-none d-print-block">State/Country Distance Report</h4>
<div [ngClass]="{ 'scroll-modal': !printView, stateCountry: printView }">
  <table class="stateTable table" id="countrychangetable">
    <thead class="bg-gray-light">
      <tr>
        <th class="border-top-0">Stop</th>
        <th class="border-top-0 text-right">
          Leg {{ distanceUnits | reportsDistanceUnit }}
        </th>
        <th class="border-top-0 text-right">
          Total {{ distanceUnits | reportsDistanceUnit }}
        </th>
        <th class="border-top-0 text-right">Leg Cost</th>
        <th class="border-top-0 text-right">Total Cost</th>
        <th class="border-top-0 text-right">Leg Hours</th>
        <th class="border-top-0 text-right">Total Hours</th>
        <th *ngIf="hasLTolls" class="border-top-0 text-right">Leg Tolls</th>
        <th *ngIf="hasTTolls" class="border-top-0 text-right">Total Tolls</th>
        <th class="border-top-0 text-right">Leg Est.GHG</th>
        <th class="border-top-0 text-right">Total Est.GHG</th>
      </tr>
    </thead>
    <tbody>
      <ng-container
        *ngFor="let reportLine of mileageReportLines; let k = index"
      >
        <tr>
          <td *ngIf="reportLine.Stop !== null">
            <app-report-stop
              [stop]="reportLine.StopDisplay"
              [routeColor]="route.color"
              [stopText]="reportLine.routeAddress"
            ></app-report-stop>
          </td>
          <td class="text-right">
            {{ reportLine.LMiles | precision : precision }}
          </td>
          <td class="text-right">
            {{ reportLine.TMiles | precision : precision }}
          </td>
          <td class="white-space-nowrap text-right">
            {{ reportLine.LCostMile | displayCurrency : displayCurrency }}
          </td>
          <td class="white-space-nowrap text-right">
            {{ reportLine.TCostMile | displayCurrency : displayCurrency }}
          </td>
          <td class="text-right">
            {{ reportLine.LHours }}
          </td>
          <td class="text-right">
            {{ reportLine.THours }}
          </td>
          <td *ngIf="hasLTolls" class="white-space-nowrap text-right">
            {{ reportLine.LTolls | displayCurrency : displayCurrency }}
          </td>
          <td *ngIf="hasTTolls" class="white-space-nowrap text-right">
            {{ reportLine.TTolls | displayCurrency : displayCurrency }}
          </td>
          <td class="text-right">
            {{ reportLine.LEstghg }}
          </td>
          <td class="text-right">
            {{ reportLine.TEstghg }}
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>

  <table class="stateTable table">
    <thead class="bg-gray-light">
      <tr>
        <th class="border-top-0">State/Country</th>
        <th class="border-top-0 text-right">Total</th>
        <th class="border-top-0 text-right">Toll</th>
        <th class="border-top-0 text-right">Freeway</th>
        <th class="border-top-0 text-right">Ferry</th>
        <th class="border-top-0 text-right">Loaded</th>
        <th class="border-top-0 text-right">Empty</th>
        <th class="border-top-0 text-right" *ngIf="hasTolls">Tolls</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let stateReportLine of stateReportLines">
        <tr
          [ngClass]="{
            'bg-gray-light font-weight-bold':
              stateReportLine.StCntry === 'TOTAL' || stateReportLine.isCountry
          }"
        >
          <td>
            {{ stateReportLine.StCntry }}
          </td>
          <td class="text-right">
            {{ stateReportLine.Total | precision : precision }}
          </td>
          <td class="text-right">
            {{ stateReportLine.Toll | number : "1.1-1" }}
          </td>
          <td class="text-right">
            {{ stateReportLine.Free | number : "1.1-1" }}
          </td>
          <td class="text-right">
            {{ stateReportLine.Ferry | number : "1.1-1" }}
          </td>
          <td class="text-right">
            {{ stateReportLine.Loaded | number : "1.1-1" }}
          </td>
          <td class="text-right">
            {{ stateReportLine.Empty | number : "1.1-1" }}
          </td>
          <td class="text-right" *ngIf="hasTolls">
            {{
              stateReportLine.Tolls
                | number : "1.2-2"
                | displayCurrency : displayCurrency
            }}
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
  <app-show-data-version [route]="route"></app-show-data-version>
</div>
